import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            内容分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按类型快速浏览，找到你感兴趣的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex flex-col items-center text-center bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-500 rounded-xl mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-semibold text-accent-500">{item.count}部</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}